import { motion, useReducedMotion } from "motion/react";
import { SparklesIcon } from "@heroicons/react/24/outline";

type QuinnEmptyStateProps = {
    pageLabel: string;
    suggestions: string[];
    onPick: (suggestion: string) => void;
};

export function QuinnEmptyState({ pageLabel, suggestions, onPick }: QuinnEmptyStateProps) {
    const prefersReducedMotion = useReducedMotion();

    return (
        <div className="flex h-full flex-col justify-center px-1 py-6">
            <motion.div
                initial={prefersReducedMotion ? false : { opacity: 0, y: 8 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.28, ease: "easeOut" }}
            >
                <img src="/quinn-green-bg.png" alt="" className="h-10 w-10 rounded-xl" />
                <h2 className="mt-3 text-base font-semibold tracking-tight text-gray-900">Waar kan ik naar kijken?</h2>
                <p className="mt-1 text-xs text-gray-500">
                    Je bekijkt <span className="font-medium text-gray-700">{pageLabel}</span>. Ik kan zoeken in transacties,
                    documenten en prognoses van je klanten.
                </p>

                <div className="mt-4 space-y-1.5">
                    {suggestions.map((suggestion, index) => (
                        <motion.button
                            key={suggestion}
                            type="button"
                            onClick={() => onPick(suggestion)}
                            initial={prefersReducedMotion ? false : { opacity: 0, y: 6 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.24, delay: 0.06 * index, ease: "easeOut" }}
                            className="group flex w-full items-start gap-2 rounded-xl border border-gray-200 bg-white px-3 py-2 text-left text-xs text-gray-700 transition-colors hover:border-primary/40 hover:bg-primary/[0.04]"
                        >
                            <SparklesIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-gray-300 transition-colors group-hover:text-primary" />
                            <span>{suggestion}</span>
                        </motion.button>
                    ))}
                </div>
            </motion.div>
        </div>
    );
}
